'use strict';
require('./CompanyTaskService.js');

function dateIsEqual(a, b) {
  if(a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }

  return false;
}

CompanyTaskNewCtrl.$inject = [
  '$scope',
  '$rootScope',
  '$controller',
  '$stateParams',
  '$state',
  '$translate',
  'publication',
  'taskTypes',
  'data',
  'CompanyUserService',
  'CompanyTaskService',
  'growl'];
function CompanyTaskNewCtrl(
  $scope,
  $rootScope,
  $controller,
  $stateParams,
  $state,
  $translate,
  publication,
  taskTypes,
  data,
  CompanyUserService,
  CompanyTaskService,
  growl) {

  angular.extend($scope, $controller('CompanyTasksCtrl', {$scope: $scope}));

  $scope.publication = publication;
  $scope.taskTypes = taskTypes;
  
  function checkDueAt() {
    if($scope.task.dueAt < $scope.task.startAt) {
      $scope.task.dueAt = new Date($scope.task.startAt.getTime());
      $scope.task.dueAt.setHours($scope.task.dueAt.getHours() + 1);
    }
  }

  var nextDate = new Date();
      nextDate.setHours(nextDate.getHours() + 1);

  var DEFAULT_TASK = {
    startAt:    new Date(),
    dueAt:      nextDate,
    assignees:  [],
    public:     true,
    wholeDay:   false,
    importance: 'NORMAL',
    type: taskTypes.length ? taskTypes[0] : null,
    createdBy: $scope.currentUser
  };
  
  if(typeof data === "object") {
    if(data.startAt) {
      DEFAULT_TASK.startAt = new Date(data.startAt);
    }
    if(data.dueAt) {
      DEFAULT_TASK.dueAt = new Date(data.dueAt);
    }
    if(data.wholeDay) {
      DEFAULT_TASK.wholeDay = !!data.wholeDay;
    }
  }

  if ($stateParams.customerId) {
    DEFAULT_TASK.connectedCustomer = {
      id: $stateParams.customerId
    };
  }

  DEFAULT_TASK.assignees.push({
    id:    $scope.currentUser.id,
    name:  $scope.currentUser.name,
    email: $scope.currentUser.email
  });

  $scope.task = new CompanyTaskService(angular.copy(DEFAULT_TASK));
  if ($scope.task.repeatEnd) {
    $scope.task.repeatEnd = new Date($scope.task.repeatEnd);
  }

  $scope.$watch("[task.dueAt, task.startAt]", function(newValue, oldValue) {
    if(newValue[0] && oldValue[0] && !dateIsEqual(newValue[0], oldValue[0]) ||
       newValue[1] && oldValue[1] && !dateIsEqual(newValue[1], oldValue[1])) {
      checkDueAt();
    }
  }, true);
  
  if(false !== $scope.publication) {
    $scope.task.publication = $scope.publication;
  }

  CompanyUserService.query({companyId: $stateParams.companyId, type: 'DEFAULT'}).$promise.then(function(users){
      return users.filter(function(item){
        return item.id !== $scope.currentUser.id;
      });
  }).then(function(users) {
    $scope.users = users;
  });

  $scope.saveTask = function() {
    $scope.task.$save({companyId: $stateParams.companyId}, function(resp){
      growl.addSuccessMessage($translate.instant('task.update-success'));
      if ($state.current.name === 'root.company.calendar') {
        $rootScope.$emit('taskCreated', resp);
      } else if($state.current.name === 'root.company.tasks') {
        $state.reload();
      }
    }, function(){
      growl.addErrorMessage($translate.instant('task.update-failure'));
    });
  };

  $scope.addAssignee = function(assignee) {
    $scope.task.assignees.push(assignee);
    angular.element('#filterAssignees').val('');
  };

  $scope.addedAssignees = function(assignee) {
    return ($scope.task.assignees.indexOf(assignee) === -1);
  };

}

angular.module('dokiv')
  .controller('CompanyTaskNewCtrl', CompanyTaskNewCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/tasks/CompanyTaskNewCtrl.js
// module id = 420
// module chunks = 0